import { createAPIService } from './api.service';

export const ACTS_ENDPOINT = '/user/api/v2/admin/acts';

const service = createAPIService(ACTS_ENDPOINT);

// endpoints
service.getActs = async params =>
  (await service.get('', { params: params })).data;

service.getAct = async id => (await service.get(`/${id}`)).data;

service.createAct = async act =>
  (
    await service.post('', {
      ...act,
      status: act.status || 'ACTIVE',
    })
  ).data;

service.updateAct = async (id, group) =>
  (
    await service.patch(`/${id}`, {
      ...group,
      id: undefined,
    })
  ).data;

service.deleteAct = async id => (await service.delete(`/${id}`)).data;

export default service;
